import { toast } from "sonner";
import { Lock, Zap, BellRing } from "lucide-react";
import { QUICK_VEHICLES, copyText, networkInviteText } from "@/lib/api";
import { t } from "@/lib/i18n";

export const QuickFilters = ({ vehicle, onVehicle }) => (
  <div className="mt-4 flex flex-wrap gap-2" data-testid="hero-vehicle-filters">
    {QUICK_VEHICLES.map((v) => (
      <button key={v.value} type="button" data-testid={`hero-vehicle-filter-${v.label.split(" ")[1].toLowerCase()}`} data-active={vehicle === v.value} onClick={() => onVehicle(vehicle === v.value ? "" : v.value)} className="ff-chip">
        {v.label.split(" ")[0]} {t(v.value)}
      </button>
    ))}
  </div>
);

export const ShareNetworkButton = () => {
  const share = async () => {
    const ok = await copyText(networkInviteText());
    ok ? toast.success("Messaggio di invito copiato: incollalo nei gruppi NCC") : toast.error("Copia non riuscita");
  };
  return (
    <button type="button" data-testid="hero-share-network-button" onClick={share} className="ff-btn-secondary mt-3 w-full sm:w-auto px-5 text-sm uppercase border-[#25D366] text-[#4ADE80]">
      {t("📲 Condividi Rete con Colleghi")}
    </button>
  );
};

const TRUST = [
  { icon: Lock, label: "Deposito Escrow Garantito", testid: "trust-escrow" },
  { icon: Zap, label: "Badge NCC Verificato sulle Flotte", testid: "trust-licenses" },
  { icon: BellRing, label: "Avvisi Smart Match in Tempo Reale", testid: "trust-smart-match" },
];

export const TrustStrip = () => (
  <div className="mt-4 flex flex-wrap gap-2 max-w-2xl" data-testid="hero-trust-strip">
    {TRUST.map(({ icon: Icon, label, testid }) => (
      <span key={label} data-testid={testid} className="ff-badge text-xs text-white border-[#3f3f46]">
        <Icon size={13} className="text-[#10B981]" /> {t(label)}
      </span>
    ))}
  </div>
);

export const HubTicker = ({ hubs, online }) => {
  const live = online ? ` • ${online} ${t("online ora")}` : "";
  const text = hubs?.length ? `${t("🟢 Rete attiva")}${live}: ${hubs.join(" • ")}` : `${t("🟢 Rete attiva")}${live} • ${t("Pubblica la prima corsa nella tua città")}`;
  return (
    <div data-testid="hub-ticker" className="ff-ticker mb-6 -mx-4 sm:mx-0 sm:rounded-full border-y sm:border border-[#10B981]/30 bg-[#10B981]/[0.06]">
      <div className="ff-ticker-track">
        {[0, 1].map((i) => (
          <span key={i} aria-hidden={i === 1} className="px-8 text-xs font-bold uppercase tracking-[0.08em] text-[#6EE7B7] whitespace-nowrap">{text}</span>
        ))}
      </div>
    </div>
  );
};
